import { Route, Routes } from 'react-router';

import TyreDetailRoute from '../tyres/TyreDetailRoute';
import Wrapper from '../tyres/Wrapper';

const MainComponent = () => (
    <div className={'overflow-hidden display-flex flex-column'}>
        <Routes>
            <Route path="/tyre-detail/:assetId/:position/:side" element={<TyreDetailRoute />} />
            <Route path="/:assetId" element={<Wrapper />} />
        </Routes>
    </div>
);

export default MainComponent;
